module.exports = __webpack_public_path__ + "img/coach-profile-banner-2.4590456a.jpg";